<template>
	
<fragment>

	<div v-for="tag in tags" :key="tag.id" class="tags-item" :style="{backgroundColor: tag.colour, color: tag.fore}" :class="{'can-change': tag.canChange}">

		<div class="tags-item-text" v-if="!tag.canChange">
			
			{{ tag.text }}
				
		</div>

		<core-dropdown trigger="manual" v-on:forceClose="is.expanded = false" :expanded="is.expanded" v-click-outside="onOutsideClick" v-if="tag.canChange">

			<div class="tags-item-text" v-on:click="onToggleClick(tag)" v-tooltip="'Click to change'">
			
				{{ tag.text }}

				<i class="fa-solid fa-caret-down" />
				
			</div>

			<core-dropdown-list title="Tag" :expanded="is.expanded" class="tags-dropdown" :caret="true" align="left" type="button" v-propagation v-on:close="is.expanded = false">

				<core-dropdown-item :key="item.id" :loading="is.loading === item.id" v-on:click="onTagToggle(item)" v-for="item in familyItems">{{ item.text }}</core-dropdown-item>

			</core-dropdown-list>

		</core-dropdown>

	</div>

</fragment>

</template>

<script>

import vClickOutside from 'v-click-outside'

export default {

	directives: {
		clickOutside: vClickOutside.directive
	},

	props: ['item'],

	data: function() {

		return {
			is: {
				expanded: false,
				loading: false
			}
		}

	},

	computed: {

		canChange: function() {

			return false

		},

		familyItems: function() {

			return this.$_.filter(this.$store.getters['data/tags/list'], function(item) {

				return item.family === this.is.expanded.family && item.id !== this.is.expanded.id

			}.bind(this))

		},

		tags: function() {

			var tags = []

			this.$_.each(this.$store.getters['data/tags/list'], function(tag) {

				if (this.$_.contains(this.item.tags, tag.id)) {

					var newTag = this.$util.copy(tag)

					if(tag.family) {

						var family = this.$store.getters['data/tagFamilies/associated'][tag.family]

						if (family.type) newTag.canChange = true

					}

					tags.push(newTag)

				}

			}.bind(this))

			return tags

		}

	},

	methods: {

		onToggleClick: function(tag) {

			if (this.is.expanded) {

				this.is.expanded = (this.is.expanded.id === tag.id) ? false : tag

			} else {

				this.is.expanded = tag

			}

		},

		onOutsideClick: function() {

			this.is.expanded = false

		},

		onTagToggle: function(tag) {

			if (this.is.loading) return

			this.is.loading = tag.id

			this.$store.dispatch('service/select/tags/toggle', {
				tag: tag,
				override: {
					item: this.item.id,
					game: this.item.game.id
				}
			}).then(function() {

				this.is.loading = false
				this.is.expanded = false

			}.bind(this), function() {

				this.is.loading = false

			}.bind(this))

		}

	}

}

</script>

<style scoped>

.tags-item {
	font-size: 11px;
	color: #fff;
	padding: 2px 4px;
	border-radius: 4px;
	display: inline-block;
	line-height: 11px;
	cursor: pointer;
	user-select: none;
	font-weight: 400;
	display: flex;
	flex-direction: row;
	cursor: initial;
}

.tags-item.can-change {
	cursor: pointer;
}

.is-desktop .tags-item .dropdown-list,
.is-tablet .tags-item .dropdown-list {
	top: 20px;
	border-radius: 4px;
	left: -4px;
	z-index: 10000;
}

.is-desktop .tags-item .dropdown-list.is-caret:after,
.is-tablet .tags-item .dropdown-list.is-caret:after {
    content: ' ';
    position: absolute;
    top: -6px;
    left: 6px;
	right: auto;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 6px 6px 6px;
    border-color: transparent transparent #316293 transparent;
}

</style>
